// extracted by mini-css-extract-plugin
export default {"root":"a21K5MxQumjoqWRI0teN","title":"om6ku04DAnMU_uNKxZ3h ayAU4x1hWAcZB0ZSQTcK t0CwDobWZhJwXPsROID2","main":"Zf4BdOcqOtWdOaTpySzi"};